import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GenericService } from '../generic.service';
import { TroubleShootEhtService } from './service/trouble-shoot-eht.service';
import { TroubleShootEs2000Service } from './service/trouble-shoot-es2000.service';
import { TroubleShootEltService } from './service/trouble-shoot-elt.service';
import { FormsModule } from '@angular/forms';
import { MachineType } from '../landing-page/service/machineType';
import { TroubleShootEultService } from './service/trouble-shoot-eult.service';
import { TroubleShootEuhtService } from './service/trouble-shoot-euht.service';
import { ApiComponentServices } from '../services/api-services';
import { defaultLanguage } from '../shared/constants/language.constants';
import { LandingService } from '../landing-page/service/landing.service';
import { CrowdinService } from '../shared/service/crowdin.service';
import { Subscription } from 'rxjs';
import { TroubleShootEh500sService } from './service/trouble-shoot-eh500s.service';
import { ResultIssuesEh500sService } from './service/result-issues-eh500s.service';

@Component({
    selector: 'app-trouble-shooting',
    imports: [CommonModule, RouterModule, FormsModule],
    templateUrl: './trouble-shooting.component.html',
    styleUrls: ['./trouble-shooting.component.scss']
})
export class TroubleShootingComponent implements OnInit {
  resultIssuesEh500s: any[] = [];
  issues: any[] = [];
  issuesEs2000: any[] = [];
  issuesElt: any[] = [];
  issuesEult: any[] = [];
  issuesEuht: any[] = [];
  issuesEh500s: any[] = [];
  deviceData: any = {};
  deviceData$: any = null;
  issueKey: string = '';
  selectedIssueCategory: string = '';
  showNextButton: boolean = false;
  selectedMachineType: string | null = null;
  qrId: any;
  accountNumber: string = '';
  accountKey: string = '';
  machineType = MachineType;
  devices: any[] = [];
  disMachineDetail: any;
  selectedDevice: any = null;
  routeId: string = '';
  isTroubleshootRoute: boolean = false;
  languageIndex: number = 0;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private troubleShootEhtService: TroubleShootEhtService,
    private troubleShootEs2000Service: TroubleShootEs2000Service,
    private troubleShootEltService: TroubleShootEltService,
    private troubleShootEultService: TroubleShootEultService,
    private troubleShootEuhtService: TroubleShootEuhtService,
    private troubleShootEh500sService: TroubleShootEh500sService,
    private resultIssuesEh500sService: ResultIssuesEh500sService,
    private router: Router,
    private route: ActivatedRoute,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
    private apiService: ApiComponentServices,
    private cdr: ChangeDetectorRef,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.languageIndex = this.crowdinService.getLanguageIndexByName(
      this.currentLanguage,
    );
    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.languageIndex =
          this.crowdinService.getLanguageIndexByName(langName);
        this.translations = this.crowdinService.getAllTranslations();
        this.loadIssues();
        this.loadResultIssues();
        this.cdr.markForCheck();
      }),
    );

    const languageCodeParam =
      this.route.snapshot.queryParamMap.get('languageCode');
    if (languageCodeParam) {
      this.currentLanguage = languageCodeParam;
      this.landingService.loadTranslations(languageCodeParam);
    } else {
      this.landingService.loadTranslations(this.currentLanguage);
    }

    this.syncLocationFromQueryParams();

    const currentUrl = this.router.url;

    if (currentUrl.startsWith('/issue-list/')) {
      this.isTroubleshootRoute = true;
      const urlSegments = currentUrl.split('/');
      const issueListIndex = urlSegments.indexOf('issue-list');
      if (issueListIndex !== -1 && urlSegments.length > issueListIndex + 1) {
        this.deviceData['routeFromMobile'] = urlSegments[issueListIndex];
        this.genericService.setLocalStorage(this.deviceData);
      }
      this.deviceData.accountKey =
        this.route.snapshot.queryParamMap.get('accountKey');
      this.deviceData.accountName =
        this.route.snapshot.queryParamMap.get('accountName');
      this.genericService.setLocalStorage(this.deviceData);
      this.genericService.deviceData.next(this.deviceData);
    } else if (currentUrl.startsWith('/issues/')) {
      this.isTroubleshootRoute = false;
    }

    this.route.paramMap.subscribe((params) => {
      this.accountNumber = params.get('accountNumber') || '';
      if (this.accountNumber) {
        if (this.isTroubleshootRoute) {
          this.loadAccountDetailsDirectly();
        }
      }
    });
    this.deviceData.selectedMachineType = this.setSelectedDevice();
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.selectedMachineType = this.setSelectedDevice();
    this.loadIssues();
    this.loadResultIssues();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  loadAccountDetailsDirectly() {
    this.apiService
      .getAccountData(this.accountNumber, '', this.accountKey)
      .subscribe((res) => {
        if (res) {
          this.deviceData = res;
          this.devices = res.Devices || [];
          this.deviceData.accountNumber = res.AccountNumber;
          this.deviceData.businessName = res.BusinessName;
          this.deviceData.languageSelected = this.currentLanguage;

          this.genericService.setLocalStorage(this.deviceData);
          this.landingService.loadTranslations(this.currentLanguage);
        }
      });
  }

  syncLocationFromQueryParams(): void {
    this.deviceData = this.genericService.syncLocationFromQueryParams(
      this.route.snapshot.queryParamMap,
      this.deviceData,
    );

    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }

  setSelectedDevice(): string | null {
    const currentMachineType =
      this.route.snapshot.queryParamMap.get('machineType');
    if (!currentMachineType) return null;

    const machineTypeUpper = currentMachineType.toUpperCase();

    if (machineTypeUpper.includes('ES2000')) {
      return MachineType.ES2000;
    }
    if (machineTypeUpper.includes('EHT')) {
      return MachineType.EHT;
    }
    if (machineTypeUpper.includes('ELT')) {
      return MachineType.ELT;
    }
    if (machineTypeUpper.includes('XLHT')) {
      return MachineType.XLHT;
    }
    if (machineTypeUpper.includes('ULT')) {
      return MachineType.EULT;
    }
    if (machineTypeUpper.includes('UHT')) {
      return MachineType.EUHT;
    }
    if (machineTypeUpper.includes('EH500S')) {
      return MachineType.EH500S;
    }
    if (machineTypeUpper.includes('XLRW')) {
      return MachineType.XLRW;
    }

    for (const key in MachineType) {
      if (MachineType[key as keyof typeof MachineType] === currentMachineType) {
        return MachineType[key as keyof typeof MachineType];
      }
    }

    return null;
  }

  loadIssues() {
    if (this.selectedMachineType === this.machineType.ES2000) {
      this.issuesEs2000 =
        this.troubleShootEs2000Service.getTroubleShootEs2000Issues();
    } else if (
      this.selectedMachineType === this.machineType.EHT ||
      this.selectedMachineType === this.machineType.XLHT ||
      this.selectedMachineType === this.machineType.XLRW
    ) {
      this.issues = this.troubleShootEhtService.getTroubleShootEhtIssues();
    } else if (this.selectedMachineType === this.machineType.ELT) {
      this.issuesElt = this.troubleShootEltService.getTroubleShootEltIssues();
    } else if (this.selectedMachineType === this.machineType.EULT) {
      this.issuesEult =
        this.troubleShootEultService.getTroubleShootEultIssues();
    } else if (this.selectedMachineType === this.machineType.EUHT) {
      this.issuesEuht =
        this.troubleShootEuhtService.getTroubleShootEuhtIssues();
    } else if (this.selectedMachineType === this.machineType.EH500S) {
      this.issuesEh500s =
        this.troubleShootEh500sService.getTroubleShootEh500sIssues();
    }
  }

  loadResultIssues() {
    if (this.selectedMachineType === this.machineType.EH500S) {
      this.resultIssuesEh500s =
        this.resultIssuesEh500sService.getResultIssuesEh500sIssues();
    }
  }

  resultIssueSelection(
    issueKey: string,
    issueName: string,
    machineType: string,
  ) {
    this.resultIssuesEh500sService.setIssuename(issueName);
    this.issueKey = issueKey;
  }

  selectResultIssue(category: string): void {
    this.selectedIssueCategory = category;
    this.showNextButton = category === 'result_issue';
    this.issueKey = '';
  }

  poorResults() {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    if (
      this.selectedMachineType === this.machineType.EHT ||
      this.selectedMachineType === this.machineType.XLHT ||
      this.selectedMachineType === this.machineType.XLRW
    ) {
      this.router.navigate([`poorresultseht/${accountNumber}`]);
    } else if (this.selectedMachineType === this.machineType.ELT) {
      this.router.navigate([`poorresultselt/${accountNumber}`]);
    } else if (this.selectedMachineType === this.machineType.EULT) {
      this.router.navigate([`poorresultseult/${accountNumber}`]);
    } else if (this.selectedMachineType === this.machineType.EUHT) {
      this.router.navigate([`poorresultseuht/${accountNumber}`]);
    }
  }

  issueSelection(issueKey: string, issueName: string, machineType: string) {
    if (machineType === this.machineType.ES2000) {
      this.troubleShootEs2000Service.setIssuename(issueName);
    } else if (
      machineType === this.machineType.EHT ||
      machineType === this.machineType.XLHT ||
      machineType === this.machineType.XLRW
    ) {
      this.troubleShootEhtService.setIssuename(issueName);
    } else if (machineType === this.machineType.ELT) {
      this.troubleShootEltService.setIssuename(issueName);
    } else if (machineType === this.machineType.EULT) {
      this.troubleShootEultService.setIssuename(issueName);
    } else if (machineType === this.machineType.EUHT) {
      this.troubleShootEuhtService.setIssuename(issueName);
    } else if (machineType === this.machineType.EH500S) {
      this.troubleShootEh500sService.setIssuename(issueName);
    }
    this.issueKey = issueKey;
  }

  selectIssueCategory(category: string) {
    this.selectedIssueCategory = category;
    this.showNextButton = category === 'machine_issue';
    this.issueKey = '';
  }

  next() {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    if (!this.issueKey) return;

    const isOtherSelected =
      typeof this.issueKey === 'string' &&
      this.issueKey.toLowerCase().endsWith('-other');

    let issueName;
    let routePath;

    if (this.selectedMachineType === this.machineType.EH500S) {
      if (this.selectedIssueCategory === 'machine_issue') {
        issueName = this.troubleShootEh500sService.getIssuename();
        routePath = `issueseh500s/${accountNumber}/${this.issueKey}`;
      } else if (this.selectedIssueCategory === 'result_issue') {
        issueName = this.resultIssuesEh500sService.getIssuename();
        routePath = `resultIssuesEh500s/${accountNumber}/${this.issueKey}`;
      }

      if (!issueName || !routePath) {
        this.router.navigate(['/errorPage']);
        return;
      }

      if (isOtherSelected) {
        this.router.navigate([`/esrSupport/${accountNumber}`]);
        return;
      }

      this.router.navigate([routePath], {
        queryParams: {
          issueName,
          issueKey: this.issueKey,
          issueType: this.selectedIssueCategory,
        },
      });

      return;
    }

    switch (this.selectedMachineType) {
      case this.machineType.ELT:
        issueName = this.troubleShootEltService.getIssuename();
        break;
      case this.machineType.EHT:
      case this.machineType.XLHT:
      case this.machineType.XLRW:
        issueName = this.troubleShootEhtService.getIssuename();
        break;
      case this.machineType.ES2000:
        issueName = this.troubleShootEs2000Service.getIssuename();
        break;
      case this.machineType.EULT:
        issueName = this.troubleShootEultService.getIssuename();
        break;
      case this.machineType.EUHT:
        issueName = this.troubleShootEuhtService.getIssuename();
        break;
      default:
        issueName = null;
        break;
    }

    if (Array.isArray(issueName)) {
      issueName = issueName.join(', ');
    }

    if (typeof issueName !== 'string') {
      this.router.navigate(['/errorPage']);
      return;
    }

    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);

    if (isOtherSelected) {
      this.router.navigate([`/esrSupport/${accountNumber}`]);
      return;
    }

    if (
      this.selectedMachineType === this.machineType.EHT ||
      this.selectedMachineType === this.machineType.XLHT ||
      this.selectedMachineType === this.machineType.XLRW
    ) {
      routePath = `issueseht/${accountNumber}/${this.issueKey}`;
    } else if (this.selectedMachineType === this.machineType.ES2000) {
      routePath = `issueses2000/${accountNumber}/${this.issueKey}`;
    } else if (this.selectedMachineType === this.machineType.ELT) {
      routePath = `issueselt/${accountNumber}/${this.issueKey}`;
    } else if (this.selectedMachineType === this.machineType.EULT) {
      routePath = `issueseult/${accountNumber}/${this.issueKey}`;
    } else if (this.selectedMachineType === this.machineType.EUHT) {
      routePath = `issueseuht/${accountNumber}/${this.issueKey}`;
    } else {
      return;
    }

    this.router.navigate([routePath], {
      queryParams: {
        issueName,
        issueKey: this.issueKey,
      },
    });
  }

  goBack() {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    history.go(-1);
  }

  navigateToLandingPage() {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate([`troubleshoot/${accountNumber}`]);
  }
}
